import React, { useEffect } from 'react';
import { useI18n } from '~Hooks';
import { useEntryFinder } from '~Components/EntryFinder';
import { CompleteExpressQueryKiosk_company_categories } from '~Scenes/SelfServiceKiosks/Components/useExpressQuery/__queries__';
import LargeItems from './LargeItems';
import SmallItems from './SmallItems';
import { FULL_IMAGE_SIZE } from '~Scenes/SelfServiceKiosks/Scenes/Item/Scenes/Details';
import { LocalItem } from '~Types';

interface Props {
  category: CompleteExpressQueryKiosk_company_categories | undefined;
  onClickItem: (id: string, instant?: boolean) => void;
  cartItems: LocalItem[];
}

const Items = ({ category, onClickItem, cartItems }: Props) => {
  const { i18n } = useI18n();
  const findEntryFromItem = useEntryFinder();

  useEffect(() => {
    if (!category) {
      return;
    }

    category.items
      .filter((item) => {
        const currentItem = findEntryFromItem(item.id);
        return Boolean(currentItem?.price);
      })
      .forEach((item) => {
        const img = new Image();

        img.src = `${item.image?.file?.url}/${FULL_IMAGE_SIZE.width * 2}x${FULL_IMAGE_SIZE.height *
          2}`;
      });
  }, [category]);

  if (!category) {
    return null;
  }

  const items = category.items
    .filter((item) => {
      const currentItem = findEntryFromItem(item.id);
      return Boolean(currentItem?.price);
    })
    .sort((a, b) => b.order - a.order);

  const large = !(i18n(category?.nameLang || '') === 'Dryck');

  if (large) {
    return <LargeItems items={items} onClickItem={onClickItem} cartItems={cartItems} />;
  } else {
    return <SmallItems items={items} onClickItem={onClickItem} cartItems={cartItems} />;
  }
};

export default Items;
